import React from 'react'

const CampanaNotificacionesListItem = ({ nombre, cantidad }) => {
  return (
    <div className="hover-background-color border-top py-1">
      <div className="row">
        <div className="col-2">
          <span className="mx-2">+{cantidad}</span>
        </div>
        <div className="col-10">
          <span className="mx-1">{nombre}</span>
        </div>
      </div>
    </div>
  )
}

export default CampanaNotificacionesListItem